import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ControllerListComponent } from './components/controller-list/controller-list.component';
import { ControllerDetailsComponent } from './components/controller-details/controller-details.component';
import { InputEditComponent } from "./components/input-edit/input-edit.component";
import { ZigbeeEditComponent } from "./components/zigbee-edit/zigbee-edit.component";
import { LinkControllerComponent } from "./components/link-controller/link-controller.component";
import { OutputEditComponent } from "./components/output-edit/output-edit.component";
import { SettingsComponent } from './components/settings/settings.component';
import { ScenarioListComponent } from './components/scenario-list/scenario-list.component';
import { SchedulerComponent } from './components/scheduler/scheduler.component';
import { FirwmareComponent } from './components/firwmare/firwmare.component';
import { TelegramComponent } from './components/telegram/telegram.component';
import { ShareAcceptComponent } from './components/share-accept/share-accept.component';

export const routes: Routes = [
  { path: '', component: ControllerListComponent },
  { path: 'share/:token', component: ShareAcceptComponent },
  { path: 'controller/:mac', component: ControllerDetailsComponent },
  { path: 'controller/:mac/settings', component: SettingsComponent },
  { path: 'input-edit/:eid', component: InputEditComponent },
  { path: 'zigbee-edit/:ieee', component: ZigbeeEditComponent },
  { path: 'output-edit/:eid', component: OutputEditComponent },
  { path: 'linkcontroller/:mac', component: LinkControllerComponent },
  { path: 'controller/:mac/scenarios', component: ScenarioListComponent },
  { path: 'controller/:mac/scheduler', component: SchedulerComponent },
  { path: 'firmware', component: FirwmareComponent },
  { path: 'telegram', component: TelegramComponent },
];
